import React from 'react';
import Header from '../../shared/Header';
import { BodyManager, TrackingWrapper } from './styled';
import { signOut } from '../../../firebase/api/auth';
import BoardList from './BoardList';
import FullPagePreloader from '../../../components/shared/FullPagePreloader';
import { usePrivateBoards } from '../../../firebase/api/boards-private';

interface IProps {
  email: string;
  currentBoard: string;
  currentUser: string;
  setCurrentBoard: (id: string) => void;
  setCurrentUser: (id: string) => void;
}

const AccountWrapper: React.FC<IProps> = (props) => {
  const { boards, loading } = usePrivateBoards();

  const currentBoardFull = boards?.find((el) => el.id === props.currentBoard);

  const currentBoardTitle = currentBoardFull?.name;
  const currentBoardInvitations = currentBoardFull?.invited;
  const currentBoardInvitationsArray =
    currentBoardInvitations &&
    Object.keys(currentBoardInvitations).map((userId) => ({
      id: userId,
      name: currentBoardInvitations[userId],
    }));

  return (
    <TrackingWrapper>
      <Header
        email={props.email}
        exit={signOut}
        currentBoardTitle={currentBoardTitle}
        currentBoardId={props.currentBoard}
        currentUserId={props.currentUser}
        currentBoardInvitationsArray={currentBoardInvitationsArray}
      />
      <BodyManager hasBoard={!!props.currentBoard || !!props.currentUser}>
        <BoardList
          boards={boards}
          setCurrentBoard={props.setCurrentBoard}
          currentBoard={props.currentBoard}
          setCurrentUser={props.setCurrentUser}
        />
        {loading ? <FullPagePreloader /> : <main>{props.children}</main>}
      </BodyManager>
    </TrackingWrapper>
  );
};

export default AccountWrapper;
